import React, {Component} from "react";
import {ServerSidePaginationTable, TableButtonsBuilder} from "../../../components/Letflow/Table";
import FilterByClient from "../../../components/Letflow/Table/FilterByClient";
import {request} from '../../../api-client'
import {
  getStoredUser,
  getStoredUserRoleId,
  ROLES,
  ROLES_IMPORTANCE,
  userIsSupervisor,
  userIsSysAdmin
} from "../../../api-client/core/authentication/utils";
import localization from "../../../config/localization";
import {makeUrlWithTableParams} from "../../../utils";
import {FormControl, FormControlLabel, Radio, RadioGroup} from "@material-ui/core/index";
import {IconButton} from "@material-ui/core";
import {Tooltip} from "recharts";
import {GetApp, Edit} from "@material-ui/icons";

const requestUsers = paginationConfig => request.user.getAll(paginationConfig)
  .then(excludeCurrentUserFromResult)
  .then(excludeTrialUsersFromResult)
  .then(addCustomPropertiesToUsersInResult)

const excludeCurrentUserFromResult = result => {
  if (showStoreUserIfWhitelisted()) {
    return result
  }
  return ({ ...result, data: result.data.filter(user => user.id !== getStoredUser().id) })
}

const excludeTrialUsersFromResult = result => ({ ...result, data: result.data.filter(user => user.role && user.role.id !== ROLES.trialId) })

const showStoreUserIfWhitelisted = () => {
  let whitelistedEmails = process.env.REACT_APP_WHITELIST_PROFILE_EDITION
  if (!whitelistedEmails) {
    return false
  }
  whitelistedEmails = whitelistedEmails.split(',')
  return whitelistedEmails.find(whitelistedEmail => whitelistedEmail === getStoredUser().email)
}

const addCustomPropertiesToUsersInResult = result => ({
  ...result,
  data: result.data.map(user => ({
    ...user,
    canHandle: ROLES_IMPORTANCE[getStoredUserRoleId()] >= ROLES_IMPORTANCE[user.role.id],
    inactive: !user.active,
  }))
})

class UsersTable extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showUsers: "all_roles",
      requestTableData: this.makeInitialTableDataRequest(),
      availablePerClient: 0,
      total: '',
    }
  }
  makeInitialTableDataRequest = () => paginationConfig => {

    if (this.state.showUsers === 'project_invitee') {
      paginationConfig = {...paginationConfig, filterBy: paginationConfig.filterBy.concat([{column: "role", filter: 'project_invitee'}])}
    }

    return requestUsers(paginationConfig)
      .then(result => {
        this.setState({ availablePerClient: FilterByClient.makeAvailablePerClientFromPaginatedResult(result) })
        return result
      })
      .then((response) => {
        this.setState({ total: response.meta.total })
        return response
        })
  }

  componentDidUpdate = (_, prevState) => {
    if (prevState.requestTableData !== this.state.requestTableData) this.table && this.table.forceUpdate()
  }

  render = () => {

    const { requestTableData } = this.state

    return (
      <div>
        <FormControl  style={{width: "100%", float: "left", position: "relative", display: "flex", flexDirection: "row"}}>
          <RadioGroup
            name="showUsers"
            value={this.state.showUsers}
            onChange={event => this.setState({ showUsers: event.target.value }, () => this.table.forceUpdate())}
            style={{ width: "100%", float: "left", position: "relative", flexDirection: "row" }}
          >
            <FormControlLabel value="all_roles" control={<Radio color="default" />} label={localization.get('users.users')} />
            <FormControlLabel value="project_invitee" control={<Radio color="default" />} label={localization.get('users.project_invitee')} />
          </RadioGroup>
          <GetApp
            onClick={() => request.user.getExportAllLink()
              .then(url => window.open(url, '_blank'))}
          style={{cursor: "pointer"}}
          />
        </FormControl>
        <div style={{ width: "100%", float: "left", position: "relative" }}>
          <ServerSidePaginationTable
            ref={r => this.table = r}
            columns={this.makeTableColumns()}
            requestTableData={requestTableData}
          />
        </div>
      </div>
    )
  }

  makeTableColumns = () => {

    const columns = []

    const nameColumn = {
      Header: localization.get('table.name'),
      accessor: "name",
      Filter: ({ filter, onChange }) => (
        <input
          onChange={event => onChange(event.target.value)}
          value={filter ? filter.value : ''}
          placeholder={localization.get('table.search')}
        />
      ),
    }

    const emailColumn = {
      Header: localization.get('table.email'),
      accessor: "email",
      Filter: ({ filter, onChange }) => (
        <input
          onChange={event => onChange(event.target.value)}
          value={filter ? filter.value : ''}
          placeholder={localization.get('table.search')}
        />
      ),
    }

    const roleColumn = {
      Header: localization.get('table.role'),
      id: "role",
      sortable: false,
      accessor: user => user.role.description,
      Filter: ({ filter, onChange }) =>
        <select style={{ width: "100%" }} onChange={event => onChange(event.target.value)} value={filter ? filter.value : ""}>
          <option value="" selected />
          {userIsSupervisor() && <option value="supervisor">{localization.get('role.supervisor')}</option>}
          {(userIsSupervisor() || userIsSysAdmin()) && <option value="sysadmin">{localization.get('role.sysadmin')}</option>}
          <option value="user">{localization.get('role.user')}</option>
        </select>,
    }

    const lastLoginColumn = {
      Header: localization.get('table.last_login'),
      id: "last_login_at",
      accessor: user => user.last_login_at ? localization.moment(user.last_login_at).fromNow() : localization.get('never'),
      filterable: false,
      maxWidth: 150,
    }

    const actionsColumn = {
      Header: localization.get('table.actions'), id: 'actions', sortable: false, filterable: false, accessor: user => {
        const builder = new TableButtonsBuilder()
        user.role.id === 3 && builder.withNotify(user.name, () => request.user.notify(user.id))

        user.canHandle && builder
          .withEdit(makeUrlWithTableParams( `/panel/users/${user.id}/edit`))
          .withDelete(user.name, () => request.user.delete(user.id), status => {
            if (status === 'passed') {
              this.table.removeById(user.id)
            }
          })
        return builder.build()
      },
      maxWidth: 150,
      Footer: <span
        style={{ float: "right", fontSize: "18px", marginTop: "15px" }}><strong>Total:  </strong>{this.state.total}</span>
    }


    columns.push(nameColumn);
    columns.push(emailColumn);
    this.state.showUsers !== 'project_invitee' && columns.push(roleColumn);
    columns.push(lastLoginColumn);
    columns.push(actionsColumn)

    return columns
  }
}

export default UsersTable
